import { AdminTableProps } from './admin-table-props';
import React from 'react';
import { Table } from '@mint/ui';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const AdminTable: React.FunctionComponent<AdminTableProps> = ({
  children,
  ...rest
}) => {
  return <StyledTable {...rest}>{children}</StyledTable>;
};
